export default function PeselDecode(pesel) {
    // http://artpi.pl/?p=8
    // Funkcja dekodujaca nr. Pesel

    var rok = parseInt(pesel.substring(0, 2), 10)
    var miesiac = parseInt(pesel.substring(2, 4), 10)
    var dzien = parseInt(pesel.substring(4, 6), 10)

    if (miesiac > 80) {
        rok = rok + 1800
        miesiac = miesiac - 80

    } else if (miesiac > 60) {
        rok = rok + 2200
        miesiac = miesiac - 60

    } else if (miesiac > 40) {
        rok = rok + 2100
        miesiac = miesiac - 40

    } else if (miesiac > 20) {
        rok = rok + 2000
        miesiac = miesiac - 20

    } else {
        rok += 1900
    }


    if (miesiac < 10)
        miesiac = '0' + miesiac

    if (dzien < 10)
        dzien = '0' + dzien


    var urodzony = rok + '-' + miesiac + '-' + dzien
    var wagi = [9, 7, 3, 1, 9, 7, 3, 1, 9, 7]
    var suma = 0


    for (var i = 0; i < wagi.length; i++) {
        suma += (parseInt(pesel.substring(i, i + 1), 10) * wagi[i])
    }


    suma = suma % 10
    var valid = (suma === parseInt(pesel.substring(10, 11), 10))


    if (parseInt(pesel.substring(9, 10), 10) % 2 === 1) {
        var plec = 'male'
    } else {
        var plec = 'female'
    }

    return {
        valid: valid,
        sex: plec,
        date: urodzony
    }
}